<template>
  <div>

    <p class="mb-10 mt-10" style="font-size: 25pt; text-align: center">
      PUBLICACIONES MULTIPLES
    </p>

    <!-- <p class="mb-10" style="font-size: 20pt; text-align: center">
      Este es tú espacio de configuracion, aquí puedes registrar, editar y
      administrar: <br />
      Variables, Indices, Clima a Largo Plazo y crear Publicaciones.
    </p> -->

    <v-card outlined>
      <v-toolbar flat>
        <v-btn @click="irAtras" icon>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-title class="grey--text"
          >{{ publicacionesMultiples.length }} Publicación (es)</v-toolbar-title
        >

        <v-spacer></v-spacer>

        <v-btn depressed color="primary" @click="irAgregarPublicacionMultiple()">
          <v-icon left dark> mdi-plus </v-icon>
          Agregar Publicación Multiple
        </v-btn>
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text>
        <v-row>
          <v-col cols="12" class="pa-0">
            <v-list v-if="publicacionesMultiples.length > 0" two-line subheader>
              <v-list-item v-for="item in publicacionesMultiples" :key="item.Name.es">
                <v-list-item-content>
                  <v-list-item-title>{{ item.Name.es }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <p class="mb-0" style="line-height: 20px">
                      {{ item.Indices.length }} Indices -
                      {{ item.Variables.length }} Variables
                      <br />
                      {{ item.Id }}
                    </p>
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-menu bottom left>
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item @click="openDialogEditPublication(item)">
                        <v-list-item-icon class="mr-3">
                          <v-icon color="blue-grey">mdi-pencil-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Editar</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="redirectToComments(item.Id)">
                        <v-list-item-icon class="mr-3">
                          <v-icon>mdi-comment-text</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <span style= "font-size: 14px;">Ver comentarios</span>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="deleteMultiplePublication(item.Id)">
                        <v-list-item-icon class="mr-3">
                          <v-icon color="red">mdi-delete-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Eliminar</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <div v-else class="my-2 d-flex justify-center">
              <p style="font-size: 12pt" class="mb-0">
                No hay publiciones registradas, !Registra una!
              </p>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="updatePublicationDialog">
      <v-card style="padding: 2rem">
        <v-form ref="formAddMultiplePublication">
          <v-row>
            <v-col cols="12">
              <v-row>
                <v-col cols="12">
                  <v-select
                    v-model="newMultiplePublication.Municipios"
                    label="Seleccionar Municipios - (maximo 10)"
                    :items="Cities"
                    item-text="Name"
                    style="margin-top:20px;"
                    :rules="rulesMultiple"
                    multiple
                    v-on:input="limiter"
                    return-object
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="newMultiplePublication.Name.es"
                    label="Titulo Publicación"
                    outlined
                    hide-details="auto"
                    required
                    :rules="rules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="newMultiplePublication.Data.LinkImage"
                    label="Link Imagen"
                    outlined
                    placeholder="https://imagepublication.png"
                    hide-details="auto"
                    required
                    :rules="rules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="newMultiplePublication.Introduction.es"
                    label="Introducción"
                    outlined
                    rows="3"
                    counter="550"
                    :rules="rules"
                  ></v-textarea>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="newMultiplePublication.Data.InitialTitle.es"
                    label="Titulo Inicial"
                    outlined
                    hide-details="auto"
                    required
                    :rules="rules"
                  ></v-text-field>
                </v-col>

                <!-- CUERPO 1 -->
                <v-col class="pt-0" cols="12">
                  <p>Cuerpo de la Publicación:</p>
                  <div
                    class="editor"
                    style="border: 1px solid #000; border-radius: 4px"
                  >
                    <editor-menu-bar
                      class="pa-2"
                      :editor="editorAdd"
                      v-slot="{ commands, isActive }"
                      style="border-bottom: 1px solid #000"
                    >
                      <div class="menubar">
                        <button
                          class="menubar__button px-1"
                          :class="{ 'is-active': isActive.bold() }"
                          @click.prevent="commands.bold"
                        >
                          <span style="font-size: 14pt">
                            <b>B</b>
                          </span>
                        </button>

                        <button
                          class="menubar__button px-1"
                          :class="{
                            'is-active': isActive.heading({ level: 1 }),
                          }"
                          @click.prevent="commands.heading({ level: 1 })"
                        >
                          <span style="font-size: 14pt">
                            <b>H1</b>
                          </span>
                        </button>

                        <button
                          class="menubar__button px-1"
                          :class="{
                            'is-active': isActive.heading({ level: 2 }),
                          }"
                          @click.prevent="commands.heading({ level: 2 })"
                        >
                          <span style="font-size: 14pt">
                            <b>H2</b>
                          </span>
                        </button>

                        <button
                          class="menubar__button px-1"
                          :class="{
                            'is-active': isActive.heading({ level: 3 }),
                          }"
                          @click.prevent="commands.heading({ level: 3 })"
                        >
                          <span style="font-size: 14pt">
                            <b>H3</b>
                          </span>
                        </button>
                      </div>
                    </editor-menu-bar>
                    <editor-content
                      class="editor__content"
                      :editor="editorAdd"
                    />
                  </div>
                  <div class="ma-2">
                    <p class="text-right">
                      {{ countersTiptap.cuerpo1 }} / 2500
                    </p>
                  </div>
                </v-col>

                <!-- INDICES -->
                <v-col cols="12">
                  <v-divider></v-divider>
                  <div class="mt-5">
                    <div class="d-flex justify-space-between align-center">
                      <div>
                        <p
                          class="mb-0"
                          style="font-size: 14pt; font-weight: 600"
                        >
                          Indices
                        </p>
                      </div>
                    </div>

                    <div style="margin-top: 1rem;">
                      <span style="font-size: 12pt; font-weight: 500; padding: 1rem"> Agrega máximo 3 variables para tu reporte</span>
                      <v-row>
                        <v-col cols="12" class="ml-2">
                          <div
                            v-for="indice in newMultiplePublication.Indices"
                            :key="indice.Id"
                          >
                          <div class='d-flex justify-space-between'>
                              <p class="mb-2" style="font-size: 14pt">
                              - {{ indice.Indice.Name.es }}
                            </p>
                              <v-btn @click="deleteIndicesFromPublication(indice)">
                                <v-icon>mdi-delete-outline</v-icon> Eliminar
                              </v-btn>
                            </div>
                            <div class="pl-2" v-html="indice.Body.es"></div>
                          </div>
                        </v-col>
                      </v-row>
                        <v-btn
                          @click="addIndiceMultiplePublication = true"
                          outlined
                          color="indigo"
                          class="mt-5"
                        >
                          <v-icon left>mdi-plus</v-icon>Agregar Indice
                        </v-btn>
                    </div>     
                  </div>
                </v-col>
                <!-- VARIABLES -->
                <v-col>
                  <v-divider></v-divider>
                  <div class="mt-6">
                    <div class="d-flex justify-space-between align-center">
                      <div>
                        <p
                          class="mb-0"
                          style="font-size: 14pt; font-weight: 700"
                        >
                          Variables 
                        </p>
                        <span style="font-size: 12pt; font-weight: 500"> Agrega máximo 3 variables para tu reporte</span>
                      </div>
                      <div>
                        <v-btn
                          @click="addVariableMultiplePublication = true"
                          outlined
                          color="indigo"
                          v-show="newMultiplePublication.Variables.length < 3"
                        >
                          <v-icon left>mdi-plus</v-icon>Agregar Variable
                        </v-btn>
                      </div>
                    </div>
                    <v-row>
                      <v-col cols="12" class="ml-2">
                        <div
                          v-for="variable in newMultiplePublication.Variables"
                          :key="variable.Id"
                        >
                         <div class='d-flex justify-space-between'>
                            <p class="mb-2" style="font-size: 14pt">
                            - {{ variable.Variable.Name.es }}
                            </p>
                            <v-btn @click="deleteVariableFromPublication(variable)">
                                <v-icon>mdi-delete-outline</v-icon> Eliminar
                            </v-btn>
                          </div>
                          <div class="pl-2" v-html="variable.Body.es"></div>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
                <v-col class="pt-0" cols="12">
                  <p>Cuerpo de la Publicación 2:</p>
                  <div
                    class="editor"
                    style="border: 1px solid #000; border-radius: 4px"
                  >
                    <editor-menu-bar
                      class="pa-2"
                      :editor="editorAdd2"
                      v-slot="{ commands, isActive }"
                      style="border-bottom: 1px solid #000"
                    >
                      <div class="menubar">
                        <button
                          class="menubar__button px-1"
                          :class="{ 'is-active': isActive.bold() }"
                          @click.prevent="commands.bold"
                        >
                          <span style="font-size: 14pt">
                            <b>B</b>
                          </span>
                        </button>

                        <button
                          class="menubar__button px-1"
                          :class="{
                            'is-active': isActive.heading({ level: 1 }),
                          }"
                          @click.prevent="commands.heading({ level: 1 })"
                        >
                          <span style="font-size: 14pt">
                            <b>H1</b>
                          </span>
                        </button>

                        <button
                          class="menubar__button px-1"
                          :class="{
                            'is-active': isActive.heading({ level: 2 }),
                          }"
                          @click.prevent="commands.heading({ level: 2 })"
                        >
                          <span style="font-size: 14pt">
                            <b>H2</b>
                          </span>
                        </button>

                        <button
                          class="menubar__button px-1"
                          :class="{
                            'is-active': isActive.heading({ level: 3 }),
                          }"
                          @click.prevent="commands.heading({ level: 3 })"
                        >
                          <span style="font-size: 14pt">
                            <b>H3</b>
                          </span>
                        </button>
                      </div>
                    </editor-menu-bar>
                    <editor-content
                      class="editor__content"
                      :editor="editorAdd2"
                    />
                  </div>
                  <div class="ma-2">
                    <p class="text-right">
                      {{ countersTiptap.cuerpo2 }} / 2500
                    </p>
                  </div>
                </v-col>

                <!-- PATROCINADORES -->
                <v-col>
                  <div class="mt-2">
                    <div class="d-flex justify-space-between align-center">
                      <div>
                        <p
                          class="mb-0"
                          style="font-size: 14pt; font-weight: 500"
                        >
                          Agregar Socios
                        </p>
                      </div>
                      <div>
                        <v-btn
                          @click="addSponsorMultiplePublication = true"
                          outlined
                          color="indigo"
                        >
                          <v-icon left>mdi-plus</v-icon>Agregar Socio
                        </v-btn>
                      </div>
                    </div>
                    <v-row>
                      <v-col cols="12" class="ml-2">
                        <div
                          v-for="sponsor in newMultiplePublication.Sponsors"
                          :key="sponsor.Id"
                        >
                          <p class="mb-2" style="font-size: 14pt">
                            {{ sponsor.Name }}
                          </p>
                          <div class="pl-2">
                            {{ sponsor.Data.description }}
                          </div>
                          <v-list-item @click="deleteSponsorFromPublication(sponsor)">
                            <v-list-item-icon class="mr-3">
                              <v-icon color="red">mdi-delete-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>Eliminar</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
                <!-- BIBLIOGRAFIA -->
                <v-col cols="12">
                  <div class="mt-2">
                    <div class="d-flex justify-space-between align-center">
                      <div>
                        <p
                          class="mb-0"
                          style="font-size: 14pt; font-weight: 500"
                        >
                          Agregar Bibliografia
                        </p>
                      </div>
                      <div>
                        <v-btn
                          @click="showAddBibliografia = true"
                          outlined
                          color="indigo"
                        >
                          <v-icon left>mdi-plus</v-icon>Agregar Bibliografia
                        </v-btn>
                      </div>
                    </div>
                    <v-row>
                      <v-col cols="12" class="ml-2">
                        <div
                          v-for="bibliografia in newMultiplePublication.Bibliografias"
                          :key="bibliografia.Text"
                        >
                          <p class="mb-2" style="font-size: 14pt">
                            {{ bibliografia.Text }}
                          </p>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <div class="my-3 mb-2 mt-6" style="display: flex; justify-content: center">
            <v-btn
              @click="updatePublication(newMultiplePublication)"
              dark
              x-large
              color="secondary"
            >
              Actualizar Publicación
            </v-btn>
          </div>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- AGREGAR INDICE PUBLICACION -->
    <v-dialog v-model="addIndiceMultiplePublication" persistent max-width="700px">
      <v-card>
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>Agregar Indice Publicación</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="addIndiceMultiplePublication = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pb-2 pt-2">
          <v-form ref="formAddIndiceMultiplePublication">
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="newIndicePublicacionMultiple.Indice"
                  :items="formMultiplePublication.indices"
                  item-text="Name.es"
                  chips
                  label="Selecciona un Indice"
                  hide-details="auto"
                  outlined
                  return-object
                  :rules="rulesMultiple"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <p>Cuerpo de Indice</p>
                <div
                  class="editor"
                  style="border: 1px solid #000; border-radius: 4px"
                >
                  <editor-menu-bar
                    class="pa-2"
                    :editor="editorAddIndice"
                    v-slot="{ commands, isActive }"
                    style="border-bottom: 1px solid #000"
                  >
                    <div class="menubar">
                      <button
                        class="menubar__button px-1"
                        :class="{ 'is-active': isActive.bold() }"
                        @click.prevent="commands.bold"
                      >
                        <span style="font-size: 14pt">
                          <b>B</b>
                        </span>
                      </button>

                      <button
                        class="menubar__button px-1"
                        :class="{ 'is-active': isActive.heading({ level: 1 }) }"
                        @click.prevent="commands.heading({ level: 1 })"
                      >
                        <span style="font-size: 14pt">
                          <b>H1</b>
                        </span>
                      </button>

                      <button
                        class="menubar__button px-1"
                        :class="{ 'is-active': isActive.heading({ level: 2 }) }"
                        @click.prevent="commands.heading({ level: 2 })"
                      >
                        <span style="font-size: 14pt">
                          <b>H2</b>
                        </span>
                      </button>

                      <button
                        class="menubar__button px-1"
                        :class="{ 'is-active': isActive.heading({ level: 3 }) }"
                        @click.prevent="commands.heading({ level: 3 })"
                      >
                        <span style="font-size: 14pt">
                          <b>H3</b>
                        </span>
                      </button>
                    </div>
                  </editor-menu-bar>
                  <editor-content
                    class="editor__content"
                    :editor="editorAddIndice"
                  />
                </div>
              </v-col>
              <v-col cols="12">
                <v-checkbox
                  class="mt-0"
                  v-model="newIndicePublicacionMultiple.Destacar"
                  label="¿Destacar este Indice?"
                  hide-details="auto"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            large
            @click="cancelDialogAddIndicePublicacionMultiple()"
            >Cancelar</v-btn
          >
          <v-btn text @click="addIndicePublicacionMultiple(newIndicePublicacionMultiple)" large
            >Guardar</v-btn
          >
        </v-card-actions>
        <v-overlay :absolute="true" :value="loadingAddMultiplePublication">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-dialog>

    <!-- AGREGAR VARIABLE PUBLICACION -->
    <v-dialog v-model="addVariableMultiplePublication" persistent max-width="700px">
      <v-card>
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>Agregar Variable Publicación</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="addVariableMultiplePublication = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pb-2 pt-2">
          <v-form ref="formAddVariableMultiplePublication">
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="newVariablePublicacionMultiple.Variable"
                  :items="formMultiplePublication.variables"
                  item-text="Name.es"
                  chips
                  label="Variables"
                  hide-details="auto"
                  outlined
                  return-object
                  :rules="rulesMultiple"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <p>Cuerpo de Variable</p>
                <div
                  class="editor"
                  style="border: 1px solid #000; border-radius: 4px"
                >
                  <editor-menu-bar
                    class="pa-2"
                    :editor="editorAddVariable"
                    v-slot="{ commands, isActive }"
                    style="border-bottom: 1px solid #000"
                  >
                    <div class="menubar">
                      <button
                        class="menubar__button px-1"
                        :class="{ 'is-active': isActive.bold() }"
                        @click.prevent="commands.bold"
                      >
                        <span style="font-size: 14pt">
                          <b>B</b>
                        </span>
                      </button>

                      <button
                        class="menubar__button px-1"
                        :class="{ 'is-active': isActive.heading({ level: 1 }) }"
                        @click.prevent="commands.heading({ level: 1 })"
                      >
                        <span style="font-size: 14pt">
                          <b>H1</b>
                        </span>
                      </button>

                      <button
                        class="menubar__button px-1"
                        :class="{ 'is-active': isActive.heading({ level: 2 }) }"
                        @click.prevent="commands.heading({ level: 2 })"
                      >
                        <span style="font-size: 14pt">
                          <b>H2</b>
                        </span>
                      </button>

                      <button
                        class="menubar__button px-1"
                        :class="{ 'is-active': isActive.heading({ level: 3 }) }"
                        @click.prevent="commands.heading({ level: 3 })"
                      >
                        <span style="font-size: 14pt">
                          <b>H3</b>
                        </span>
                      </button>
                    </div>
                  </editor-menu-bar>
                  <editor-content
                    class="editor__content"
                    :editor="editorAddVariable"
                  />
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            large
            @click="cancelDialogAddVariablePublicacionMultiple()"
            >Cancelar</v-btn
          >
          <v-btn
            text
            @click="addVariablePublicacionMultiple(newVariablePublicacionMultiple)"
            large
            >Guardar</v-btn
          >
        </v-card-actions>
        <v-overlay :absolute="true" :value="loadingAddMultiplePublication">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-dialog>
    <!-- AGREGAR BIBLIOGRAFIA PUBLICACION -->
    <v-dialog v-model="showAddBibliografia" persistent max-width="700px">
      <v-card>
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>Agregar Socio Publicación</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="showAddBibliografia = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div style="padding: 1rem">
          <v-text-field
            class="mb-3"
            v-model="newBibliografia.Url"
            label="URL - la url debe estar completa (e.j: http://www.cultivandofuturo.com)"
            outlined
            hide-details="auto"
            required
            :rules="urlRule"
          ></v-text-field>
          <v-text-field
            v-model="newBibliografia.Text"
            label="Texto"
            outlined
            hide-details="auto"
            required
            :rules="rules"
          ></v-text-field>
        </div>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            large
            @click="cancelDialogAddSponsorPublicacion()"
            >Cancelar</v-btn
          >
          <v-btn
            text
            @click="addBiografiaPublicacion()"
            large
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- AGREGAR PATROCINADORES PUBLICACION -->
    <v-dialog v-model="addSponsorMultiplePublication" persistent max-width="700px">
      <v-card>
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>Agregar Socio Publicación</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="addSponsorMultiplePublication = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pb-2 pt-2">
          <v-form ref="formAddVariableMultiplePublication">
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="newSponsorMultiplePublication"
                  :items="formMultiplePublication.patrocinadores"
                  item-text="Name"
                  chips
                  label="Socios"
                  hide-details="auto"
                  outlined
                  return-object
                  :rules="rulesMultiple"
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            large
            @click="cancelDialogAddSponsorPublicacionMultiple()"
            >Cancelar</v-btn
          >
          <v-btn
            text
            @click="addSponsorPublicacionMultiple()"
            large
            >Guardar</v-btn
          >
        </v-card-actions>
        <v-overlay :absolute="true" :value="loadingAddMultiplePublication">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      bottom
      :color="snackbar.color"
      :timeout="5000"
      >{{ snackbar.text }}</v-snackbar
    >

    <v-overlay :value="loadingScreen">
      <v-progress-circular
        class="mb-4"
        indeterminate
        size="64"
      ></v-progress-circular>
      <p>Cargando...</p>
    </v-overlay>
  </div>
</template>

<script>
import api from "@/api/api";
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import { Heading, Bold } from "tiptap-extensions";

export default {
  name: "Home",
  components: {
    EditorContent,
    EditorMenuBar,
  },
  data() {
    return {
      Cities: [
          {
            Id: 401,
            Hash: "hn-cp-sc",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Santa Rosa de Copán",
          },
          {
            Id: 402,
            Hash: "hn-cp-ca",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Cabañas",
          },
          {
            Id: 403,
            Hash: "hn-cp-cn",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Concepción",
          },
          {
            Id: 404,
            Hash: "hn-cp-cr",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Copán Ruinas",
          },
          {
            Id: 405,
            Hash: "hn-cp-cq",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Corquín",
          },
          {
            Id: 406,
            Hash: "hn-cp-cu",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Cucuyagua",
          },
          {
            Id: 407,
            Hash: "hn-cp-do",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Dolores",
          },
          {
            Id: 408,
            Hash: "hn-cp-dn",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Dulce Nombre",
          },
          {
            Id: 409,
            Hash: "hn-cp-ep",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "El Paraíso",
          },
          {
            Id: 410,
            Hash: "hn-cp-fl",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Florida",
          },
          {
            Id: 411,
            Hash: "hn-cp-lj",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "La Jigua",
          },
          {
            Id: 412,
            Hash: "hn-cp-lu",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "La Unión",
          },
          {
            Id: 413,
            Hash: "hn-cp-na",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Nueva Arcadia",
          },
          {
            Id: 414,
            Hash: "hn-cp-sg",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "San Agustín",
          },
          {
            Id: 415,
            Hash: "hn-cp-sa",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "San Antonio",
          },
          {
            Id: 416,
            Hash: "hn-cp-sm",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "San Jerónimo",
          },
          {
            Id: 417,
            Hash: "hn-cp-sj",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "San José",
          },
          {
            Id: 418,
            Hash: "hn-cp-so",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "San Juan de Opoa",
          },
          {
            Id: 419,
            Hash: "hn-cp-sn",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "San Nicolás",
          },
          {
            Id: 420,
            Hash: "hn-cp-sp",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "San Pedro de Copán",
          },
          {
            Id: 421,
            Hash: "hn-cp-sr",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Santa Rita",
          },
          {
            Id: 422,
            Hash: "hn-cp-tc",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Trinidad de Copán",
          },
          {
            Id: 423,
            Hash: "hn-cp-ve",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Veracruz",
          },
          {
            Id: 601,
            Hash: "hn-ch-ch",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Choluteca",
          },
          {
            Id: 602,
            Hash: "hn-ch-ap",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Apacilagua",
          },
          {
            Id: 603,
            Hash: "hn-ch-cm",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Concepción de Maria",
          },
          {
            Id: 604,
            Hash: "hn-ch-du",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Duyure",
          },
          {
            Id: 605,
            Hash: "hn-ch-ec",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "El Corpus",
          },
          {
            Id: 606,
            Hash: "hn-ch-et",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "El Triunfo",
          },
          {
            Id: 607,
            Hash: "hn-ch-ma",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Marcovia",
          },
          {
            Id: 608,
            Hash: "hn-ch-mo",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Morolica",
          },
          {
            Id: 609,
            Hash: "hn-ch-na",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Namasigue",
          },
          {
            Id: 610,
            Hash: "hn-ch-or",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Orocuina",
          },
          {
            Id: 611,
            Hash: "hn-ch-pe",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Pespire",
          },
          {
            Id: 612,
            Hash: "hn-ch-sf",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "San Antonio de Flores",
          },
          {
            Id: 613,
            Hash: "hn-ch-si",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "San Isidro",
          },
          {
            Id: 614,
            Hash: "hn-ch-sj",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "San José",
          },
          {
            Id: 615,
            Hash: "hn-ch-sm",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "San Marcos de Colón",
          },
          {
            Id: 616,
            Hash: "hn-ch-sy",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Santa Ana de Yusguare",
          },
          {
            Id: 701,
            Hash: "hn-ep-yu",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Yuscarán",
          },
          {
            Id: 702,
            Hash: "hn-ep-al",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Alauca",
          },
          {
            Id: 705,
            Hash: "hn-ep-gu",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Güinope",
          },
          {
            Id: 707,
            Hash: "hn-ep-li",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Liure",
          },
          {
            Id: 708,
            Hash: "hn-ep-mo",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Morocelí",
          },
          {
            Id: 709,
            Hash: "hn-ep-or",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Oropolí",
          },
          {
            Id: 711,
            Hash: "hn-ep-sa",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "San Antonio de Flores",
          },
          {
            Id: 712,
            Hash: "hn-ep-sl",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "San Lucas",
          },
          {
            Id: 714,
            Hash: "hn-ep-so",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Soledad",
          },
          {
            Id: 716,
            Hash: "hn-ep-tx",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Texiguat",
          },
          {
            Id: 717,
            Hash: "hn-ep-va",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Vado Ancho",
          },
          {
            Id: 718,
            Hash: "hn-ep-ya",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Yauyupe",
          },
          {
            Id: 801,
            Hash: "hn-fm-dc",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Distrito Central",
          },
          {
            Id: 802,
            Hash: "hn-fm-al",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Alubarén",
          },
          {
            Id: 804,
            Hash: "hn-fm-cu",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Curarén",
          },
          {
            Id: 807,
            Hash: "hn-fm-ll",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "La Libertad",
          },
          {
            Id: 808,
            Hash: "hn-fm-lv",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "La Venta",
          },
          {
            Id: 809,
            Hash: "hn-fm-le",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Lepaterique",
          },
          {
            Id: 810,
            Hash: "hn-fm-mt",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Maraita",
          },
          {
            Id: 812,
            Hash: "hn-fm-na",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Nueva Armenia",
          },
          {
            Id: 813,
            Hash: "hn-fm-oj",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Ojojona",
          },
          {
            Id: 815,
            Hash: "hn-fm-re",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Reitoca",
          },
          {
            Id: 816,
            Hash: "hn-fm-sg",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Sabanagrande",
          },
          {
            Id: 817,
            Hash: "hn-fm-so",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "San Antonio de Oriente",
          },
          {
            Id: 818,
            Hash: "hn-fm-sb",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "San Buenaventura",
          },
          {
            Id: 820,
            Hash: "hn-fm-sj",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "San Juan de Flores",
          },
          {
            Id: 821,
            Hash: "hn-fm-sm",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "San Miguelito",
          },
          {
            Id: 822,
            Hash: "hn-fm-sa",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Santa Ana",
          },
          {
            Id: 823,
            Hash: "hn-fm-sl",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Santa Lucía",
          },
          {
            Id: 825,
            Hash: "hn-fm-tt",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Tatumbla",
          },
          {
            Id: 826,
            Hash: "hn-fm-va",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Valle de Ángeles",
          },
          {
            Id: 827,
            Hash: "hn-fm-vs",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Villa de San Francisco",
          },
          {
            Id: 1001,
            Hash: "hn-in-le",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "La Esperanza",
          },
          {
            Id: 1002,
            Hash: "hn-in-ca",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "Camasca",
          },
          {
            Id: 1003,
            Hash: "hn-in-cl",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "Colomoncagua",
          },
          {
            Id: 1004,
            Hash: "hn-in-cn",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "Concepción",
          },
          {
            Id: 1005,
            Hash: "hn-in-do",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "Dolores",
          },
          {
            Id: 1006,
            Hash: "hn-in-in",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "Intibucá",
          },
          {
            Id: 1008,
            Hash: "hn-in-md",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "Magdalena",
          },
          {
            Id: 1010,
            Hash: "hn-in-sa",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "San Antonio",
          },
          {
            Id: 1012,
            Hash: "hn-in-sj",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "San Juan",
          },
          {
            Id: 1013,
            Hash: "hn-in-ss",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "San Marcos de La Sierra",
          },
          {
            Id: 1014,
            Hash: "hn-in-sm",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "San Miguelito",
          },
          {
            Id: 1015,
            Hash: "hn-in-sl",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "Santa Lucía",
          },
          {
            Id: 1016,
            Hash: "hn-in-ya",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "Yamaranguila",
          },
          {
            Id: 1017,
            Hash: "hn-in-sf",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "San Francisco de Opalaca",
          },
          {
            Id: 1202,
            Hash: "hn-lp-ag",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Aguanqueterique",
          },
          {
            Id: 1203,
            Hash: "hn-lp-cb",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Cabañas",
          },
          {
            Id: 1206,
            Hash: "hn-lp-gu",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Guajiquiro",
          },
          {
            Id: 1207,
            Hash: "hn-lp-la",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Lauterique",
          },
          {
            Id: 1208,
            Hash: "hn-lp-ma",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Marcala",
          },
          {
            Id: 1209,
            Hash: "hn-lp-mo",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Mercedes de Oriente",
          },
          {
            Id: 1210,
            Hash: "hn-lp-op",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Opatoro",
          },
          {
            Id: 1211,
            Hash: "hn-lp-sn",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "San Antonio del Norte",
          },
          {
            Id: 1213,
            Hash: "hn-lp-su",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "San Juan",
          },
          {
            Id: 1215,
            Hash: "hn-lp-sa",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Santa Ana",
          },
          {
            Id: 1216,
            Hash: "hn-lp-se",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Santa Elena",
          },
          {
            Id: 1219,
            Hash: "hn-lp-ya",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Yarula",
          },
          {
            Id: 1301,
            Hash: "hn-le-gr",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Gracias",
          },
          {
            Id: 1302,
            Hash: "hn-le-be",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Belén",
          },
          {
            Id: 1303,
            Hash: "hn-le-ca",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Candelaria",
          },
          {
            Id: 1304,
            Hash: "hn-le-co",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Cololaca",
          },
          {
            Id: 1305,
            Hash: "hn-le-er",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Erandique",
          },
          {
            Id: 1306,
            Hash: "hn-le-gc",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Gualcince",
          },
          {
            Id: 1307,
            Hash: "hn-le-gt",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Guarita",
          },
          {
            Id: 1308,
            Hash: "hn-le-lc",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "La Campa",
          },
          {
            Id: 1309,
            Hash: "hn-le-li",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "La Iguala",
          },
          {
            Id: 1310,
            Hash: "hn-le-lf",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Las Flores",
          },
          {
            Id: 1311,
            Hash: "hn-le-lu",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "La Unión",
          },
          {
            Id: 1312,
            Hash: "hn-le-lv",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "La Virtud",
          },
          {
            Id: 1313,
            Hash: "hn-le-le",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Lepaera",
          },
          {
            Id: 1314,
            Hash: "hn-le-ma",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Mapulaca",
          },
          {
            Id: 1315,
            Hash: "hn-le-pi",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Piraera",
          },
          {
            Id: 1316,
            Hash: "hn-le-sa",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "San Andrés",
          },
          {
            Id: 1317,
            Hash: "hn-le-sf",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "San Francisco",
          },
          {
            Id: 1318,
            Hash: "hn-le-sj",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "San Juan Guarita",
          },
          {
            Id: 1319,
            Hash: "hn-le-sh",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "San Manuel Colohete",
          },
          {
            Id: 1320,
            Hash: "hn-le-sr",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "San Rafael",
          },
          {
            Id: 1321,
            Hash: "hn-le-ss",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "San Sebastián",
          },
          {
            Id: 1322,
            Hash: "hn-le-sc",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Santa Cruz",
          },
          {
            Id: 1323,
            Hash: "hn-le-tg",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Talgua",
          },
          {
            Id: 1324,
            Hash: "hn-le-tb",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Tambla",
          },
          {
            Id: 1325,
            Hash: "hn-le-to",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Tomalá",
          },
          {
            Id: 1326,
            Hash: "hn-le-va",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Valladolid",
          },
          {
            Id: 1327,
            Hash: "hn-le-vi",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Virginia",
          },
          {
            Id: 1328,
            Hash: "hn-le-sm",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "San Marcos de Caiquín",
          },
          {
            Id: 1401,
            Hash: "hn-oc-oc",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Ocotepeque",
          },
          {
            Id: 1402,
            Hash: "hn-oc-bg",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Belén Gualcho",
          },
          {
            Id: 1403,
            Hash: "hn-oc-co",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Concepción",
          },
          {
            Id: 1404,
            Hash: "hn-oc-dm",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Dolores Merendón",
          },
          {
            Id: 1405,
            Hash: "hn-oc-fr",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Fraternidad",
          },
          {
            Id: 1406,
            Hash: "hn-oc-le",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "La Encarnación",
          },
          {
            Id: 1407,
            Hash: "hn-oc-ll",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "La Labor",
          },
          {
            Id: 1408,
            Hash: "hn-oc-lu",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Lucerna",
          },
          {
            Id: 1409,
            Hash: "hn-oc-me",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Mercedes",
          },
          {
            Id: 1410,
            Hash: "hn-oc-sf",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "San Fernando",
          },
          {
            Id: 1411,
            Hash: "hn-oc-sv",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "San Francisco del Valle",
          },
          {
            Id: 1412,
            Hash: "hn-oc-sj",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "San Jorge",
          },
          {
            Id: 1413,
            Hash: "hn-oc-sm",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "San Marcos",
          },
          {
            Id: 1414,
            Hash: "hn-oc-st",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Santa Fé",
          },
          {
            Id: 1415,
            Hash: "hn-oc-se",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Sensenti",
          },
          {
            Id: 1416,
            Hash: "hn-oc-si",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Sinuapa",
          },
          {
            Id: 1612,
            Hash: "hn-sb-il",
            State: { Hash: "hn-sb", Id: 16, Name: "Santa Bárbara" },
            Name: "Ilama",
          },
          {
            Id: 1613,
            Hash: "hn-sb-ma",
            State: { Hash: "hn-sb", Id: 16, Name: "Santa Bárbara" },
            Name: "Macuelizo",
          },
          {
            Id: 1616,
            Hash: "hn-sb-pe",
            State: { Hash: "hn-sb", Id: 16, Name: "Santa Bárbara" },
            Name: "Petoa",
          },
          {
            Id: 1628,
            Hash: "hn-sb-nf",
            State: { Hash: "hn-sb", Id: 16, Name: "Santa Bárbara" },
            Name: "Nueva Frontera",
          },
          {
            Id: 1701,
            Hash: "hn-va-na",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "Nacaome",
          },
          {
            Id: 1702,
            Hash: "hn-va-al",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "Alianza",
          },
          {
            Id: 1703,
            Hash: "hn-va-am",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "Amapala",
          },
          {
            Id: 1704,
            Hash: "hn-va-ar",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "Aramecina",
          },
          {
            Id: 1705,
            Hash: "hn-va-ca",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "Caridad",
          },
          {
            Id: 1706,
            Hash: "hn-va-go",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "Goascorán",
          },
          {
            Id: 1707,
            Hash: "hn-va-la",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "Langue",
          },
          {
            Id: 1708,
            Hash: "hn-va-sf",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "San Francisco de Coray",
          },
          {
            Id: 1709,
            Hash: "hn-va-sl",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "San Lorenzo",
          },
        ],
      publicacionesMultiples: [],
      formMultiplePublication: {
        indices: [],
        variables: [],
        patrocinadores: [],
      },
      newBibliografia:{
        Text: null,
        Url: null
      },
      showAddBibliografia: false,
      newMultiplePublication: {
        Name: {
          es: null,
        },
        Introduction: {
          es: null,
        },
        Body: {
          es: {
            First: null,
            Second: null,
          },
        },
        EscenariosClimaticos: {
          Show: false,
          BodyTemperatura: {
            es: null,
          },
          BodyPrecipitacion: {
            es: null,
          },
        },
        Indices: [],
        Variables: [],
        Data: {
          LinkImage: null,
          InitialTitle: {
            es: null,
          },
        },
        Sponsors: [],
        Municipios: [],
        Bibliografias:[]
      },
      addMultiplePublicationDialog: false,
      addIndiceMultiplePublication: false,
      newIndicePublicacionMultiple: {
        Indice: null,
        Body: {
          es: null,
        },
        Destacar: false,
      },
      loadingAddMultiplePublication: false,
      addVariableMultiplePublication: false,
      addSponsorMultiplePublication: false,
      newSponsorMultiplePublication:{},
      addVariablePublication: false,
      newVariablePublicacionMultiple: {
        Variable: null,
        Body: {
          es: null,
        },
        chartType: "",
      },
      rules: [(v) => !!v || "Este campo es requerido"],
      rulesMultiple: [
        (v) => {
          if (!v || v.length < 1) {
            return "Este campo es requerido";
          } else {
            return true;
          }
        },
      ],
      urlRule:[(v)=> {
        if (!v || v.length < 1) {
          return "Este campo es requerido";
        } else if (!/^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(v)){
          return "URL invalida"
        } else {
          return true;
        }
      }],
      loadingAddPublication: false,
      updatePublicationDialog: false,
      editorAdd: new Editor({
        extensions: [new Heading({ levels: [1, 2, 3] }), new Bold()],
        content: "",
        onUpdate: ({ getHTML }) => {
          this.newMultiplePublication.Body.es.First = getHTML();
        },
      }),
      countersTiptap: {
        cuerpo1: 0,
        cuerpo2: 0,
      },
      editorAdd2: new Editor({
        extensions: [new Heading({ levels: [1, 2, 3] }), new Bold()],
        content: "",
        onUpdate: ({ getHTML }) => {
          this.newMultiplePublication.Body.es.Second = getHTML();
        },
      }),
      editorAddIndice: new Editor({
        extensions: [new Heading({ levels: [1, 2, 3] }), new Bold()],
        content: "",
        onUpdate: ({ getHTML }) => {
          this.newIndicePublicacion.Body.es = getHTML();
        },
      }),
      editorAddVariable: new Editor({
        extensions: [new Heading({ levels: [1, 2, 3] }), new Bold()],
        content: "",
        onUpdate: ({ getHTML }) => {
          this.newVariablePublicacion.Body.es = getHTML();
        },
      }),
      snackbar: {
        show: false,
        text: null,
        color: null,
      },
      loadingScreen: false,
    };
  },
  mounted() {
    this.getPublicacionesMultiples();
  },
  methods: {
    limiter(e) {
      if(e.length > 10) {
        e.pop()
      }
    },
    addSponsorPublicacionMultiple() {
      try {
        this.newMultiplePublication.Sponsors.push(this.newSponsorMultiplePublication);
        this.addSponsorMultiplePublication = false;
        this.newSponsorMultiplePublication = null;
      } catch (err) {
        console.log(err);
      }
    },
    async getPublicacionesMultiples() {
      try {
        const data = await api.getMultiplePublicaciones();
        if (data.data.status) {
          this.publicacionesMultiples = data.data.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getIndices() {
      try {
        const data = await api.getIndices();

        if (data.status) {
          this.formMultiplePublication.indices = data.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getVariables() {
      try {
        const data = await api.getVariables();

        if (data.status) {
          this.formMultiplePublication.variables = data.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    cancelDialogAddPublication() {
      this.addPublicationDialog = false;
    },
    addIndicePublicacionMultiple(data) {
      try {
        this.newMultiplePublication.Indices.push(data);
        this.newIndicePublicacionMultiple = {
          Indice: null,
          Body: {
            es: null,
          },
          Destacar: false,
        };
        this.editorAddIndice.clearContent();
        this.addIndiceMultiplePublication = false;
      } catch (err) {
        console.log(err);
      }
    },
     addVariablePublicacionMultiple(data) {
      try {
        this.newMultiplePublication.Variables.push(data);
        this.newVariablePublicacionMultiple = {
          Variable: null,
          Body: {
            es: null,
          },
          chartType: "",
        };
        this.editorAddVariable.clearContent();
        this.addVariableMultiplePublication = false;
      } catch (err) {
        console.log(err);
      }
    },
    cancelDialogAddIndicePublicacion() {
      this.addIndicePublication = false;
    },
    addVariablePublicacion(data) {
      try {
        this.newPublication.Variables.push(data);
        this.newVariablePublicacion = {
          Variable: null,
          Body: {
            es: null,
          },
        };
        this.editorAddVariable.clearContent();
        this.addVariablePublication = false;
      } catch (err) {
        console.log(err);
      }
    },
    cancelDialogAddVariablePublicacion() {
      this.addVariablePublication = false;
    },
    async updatePublication(newPublication) {
      try {
        if (this.$refs.formAddMultiplePublication.validate()) {
          this.loadingAddPublication = true;
          const data = await api.updateMultiplePublication(newPublication, newPublication.Id);
          if (data.status) {
            this.updatePublicationDialog = false;
            this.newMultiplePublication = {
              Name: {
                es: null,
              },
              Introduction: {
                es: null,
              },
              Body: {
                es: {
                  First: null,
                  Second: null,
                },
              },
              EscenariosClimaticos: {
                Show: false,
                BodyTemperatura: {
                  es: null,
                },
                BodyPrecipitacion: {
                  es: null,
                },
              },
              Indices: [],
              Variables: [],
              Data: {
                LinkImage: null,
                InitialTitle: {
                  es: null,
                },
              },
              Sponsors: [],
              Bibliografias:[]
            },
            this.editorAdd.clearContent();
            this.$refs.formAddMultiplePublication.reset();
            this.addPublicationDialog = false;
            this.getPublicacionesMultiples();
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    cancelDialogAddPublicacion() {
      this.$refs.formAddPublication.reset();
      this.addPublicationDialog = false;
    },
    addSponsorPublicacion() {
      try {
        this.newPublication.Sponsors.push(this.newSponsorPublication);
        this.addSponsorPublication = false;
        this.newSponsorPublication = null;
      } catch (err) {
        console.log(err);
      }
    },
    deleteSponsorFromPublication(psponsor) {
      this.newMultiplePublication.Sponsors = this.newMultiplePublication.Sponsors.filter(sponsor => psponsor !== sponsor);
    },
    deleteVariableFromPublication(pvariable) {
      this.newMultiplePublication.Variables = this.newMultiplePublication.Variables.filter(variable => pvariable !== variable);
    },
    deleteIndicesFromPublication(pindice) {
      this.newMultiplePublication.Indices = this.newMultiplePublication.Indices.filter(indice => pindice !== indice);
    },
    async getPatrocinadores() {
      try {
        this.loadingScreen = true;
        const data = await api.getPatrocinadores();
        if (data.data.status) {
          this.formMultiplePublication.patrocinadores = data.data.data;
        }
        this.loadingScreen = false;
      } catch (err) {
        console.log(err);
      }
    },
    addBiografiaPublicacion() {
      try {
        this.newMultiplePublication.Bibliografias.push({...this.newBibliografia});
        this.showAddBibliografia = false;
        this.newBibliografia.Text = null;
        this.newBibliografia.Url = null;
      } catch (err) {
        console.log(err);
      }
    },
    openDialogEditPublication(item) {
      this.newMultiplePublication = item;
      this.getIndices();
      this.getVariables();
      this.getPatrocinadores();
      this.editorAdd.setContent(item.Body.es.First)
      this.editorAdd2.setContent(item.Body.es.Second)
      this.updatePublicationDialog = true;
    },
    cancelDialogEditPublication() {
      this.updatePublicationDialog = false;
    },
    async deleteMultiplePublication(idPublication) {
      try {
        this.loadingScreen = true;
        let data = await api.deleteMultiplePublication(idPublication);
        this.loadingScreen = false;
        this.showSnackbar("La publicación se eliminó correctamente", "success");
        this.getPublicacionesMultiples();
      } catch (err) {
        console.err(err);
      }
    },
    showSnackbar(message, color) {
      this.snackbar.text = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    irAgregarPublicacionMultiple() {
      this.$router.push("/admin/publicaciones-multiples/agregar");
    },
    irAtras() {
      this.$router.go(-1);
    },
    redirectToComments(id) {
      this.$router.push({ path: `/admin/publicaciones-multiples/${id}/comments` })
    }
  },
  beforeDestroy() {
    // Always destroy your editor instance when it's no longer needed
    if (this.editor) {
      this.editor.destroy();
    }
  },
};
</script>